import React from "react";

interface LoadingProps {
  message?: string; // Optional contextual message
  size?: "small" | "medium" | "large"; // Spinner size
}

const spinnerSizes = {
  small: "w-6 h-6",
  medium: "w-10 h-10",
  large: "w-16 h-16",
};

export default function Loading({
  message = "Loading...",
  size = "medium",
}: LoadingProps) {
  return (
    <div className="flex flex-col items-center justify-center p-6 space-y-2 min-h-[200px]">
      <div
        className={`border-4 border-t-4 border-gray-300 border-t-indigo-500 rounded-full animate-spin ${spinnerSizes[size]}`}
      ></div>
      <span className="text-gray-700 text-sm font-medium">{message}</span>
    </div>
  );
}
